<template>
    <div>
        <a class="btn btn-xl btn-outline-primary btn-round mr-1 mb-2 mb-lg-0 text-uppercase" href="#curricula">{{ $t("coursesPage.curriculaBtn") }}</a>
        <a class="btn btn-xl btn-secondary btn-round text-uppercase" href="#offer">{{ $t("privateSchoolsPage.offerBtn") }}</a>
    </div>
</template>

<script>
export default {
  name: "schoolsCtaBtns"
};
</script>
